import useEnforceListAccess from 'hooks/list-library/useEnforceListAccess';
import useMixinListSummaries from 'hooks/list-library/useMixinListSummaries';
import useRefreshLists from 'hooks/list-library/useRefreshLists';
import useSyncActiveList from 'hooks/list-library/useSyncActiveList';
import useSyncRecentLists from 'hooks/list-library/useSyncRecentLists';

export const ListLibraryListeners = () => {
  useRefreshLists();

  useMixinListSummaries();

  useSyncActiveList();

  useEnforceListAccess();

  useSyncRecentLists();

  return null;
};
